import React from 'react';
import { DecisionTreeNodeFieldsFragment, DecisionTreeRunFieldsFragment, useGetDecisionTreeQuery } from '../../../../../generated/core-api/graphql-react-query';
import { DecisionTreeInfoContextProps } from '../useDecisionTreeInfoContext';

export default function useNodeHistory(run: DecisionTreeRunFieldsFragment | null): DecisionTreeInfoContextProps {
  const decisionTreeId = run?.decisionTreeId;
  const decisionTree = useGetDecisionTreeQuery({ input: { id: decisionTreeId ?? '' } }, { enabled: !!decisionTreeId });

  const nodeMap = React.useMemo(() => {
    if (!decisionTree.data) return null;
    const map = new Map<string, DecisionTreeNodeFieldsFragment>();
    decisionTree.data?.getDecisionTree?.nodes.forEach((node) => {
      map.set(node.id, node);
    });
    return map;
  }, [decisionTree.data?.getDecisionTree?.nodes]);

  const nodeHistory: DecisionTreeInfoContextProps['nodeHistory'] = React.useMemo(() => {
    if (!run) { return []; }
    if (!nodeMap) { return []; }
    return run.history.map((h) => {
      const node = nodeMap.get(h.nodeId);
      if (!node) {
        throw new Error('Node not found');
      }
      return { ...h, node };
    });
  }, [run, nodeMap]);

  const value = React.useMemo(() => ({
    decisionTree: decisionTree.data?.getDecisionTree ?? null,
    nodeHistory,
  }), [decisionTree.data, nodeHistory]);
  return value;
}
